const months = ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Desembre']
export default months



/** WEBPACK FOOTER **
 ** ./src/data/months.js
 **/